var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "bl_area capture_area" }, [
    _c(
      "form",
      {
        attrs: { id: "frm_shipping" },
        on: {
          submit: function ($event) {
            $event.preventDefault()
          },
        },
      },
      [
        _c("h2", { staticClass: "content_title" }, [
          _vm._v(_vm._s(_vm.$t("msg.CSBL200.231"))),
        ]),
        _c("table", { staticClass: "tbl_col" }, [
          _vm._m(0),
          _c("tbody", [
            _c("tr", [
              _c("th", { staticClass: "text_left" }, [
                _vm._v(" " + _vm._s(_vm.$t("msg.NEWB020G010.043")) + " "),
              ]),
              _c(
                "td",
                [
                  _c("e-trans-address-input", {
                    ref: "actShprCstEnm",
                    attrs: {
                      id: "actShprCstEnm",
                      "is-required": true,
                      "is-char": true,
                      "max-length": 50,
                      "message-required": _vm.$t("msg.CSBK100.147"),
                    },
                    on: {
                      input: function ($event) {
                        return _vm.checkValidationInfo("actShprCstEnm")
                      },
                    },
                    model: {
                      value: _vm.regParams.actShprCstEnm,
                      callback: function ($$v) {
                        _vm.$set(_vm.regParams, "actShprCstEnm", $$v)
                      },
                      expression: "regParams.actShprCstEnm",
                    },
                  }),
                ],
                1
              ),
              _c("th", { staticClass: "text_left" }, [
                _vm._v(" " + _vm._s(_vm.$t("msg.NEWB020G010.044")) + " "),
              ]),
              _c(
                "td",
                [
                  _c("e-trans-address-input", {
                    ref: "cneCstEnm",
                    attrs: {
                      id: "cneCstEnm",
                      "is-required": true,
                      "is-char": true,
                      "max-length": 50,
                      "message-required": _vm.$t("msg.CSBK100.147"),
                    },
                    on: {
                      input: function ($event) {
                        return _vm.checkValidationInfo("cneCstEnm")
                      },
                    },
                    model: {
                      value: _vm.regParams.cneCstEnm,
                      callback: function ($$v) {
                        _vm.$set(_vm.regParams, "cneCstEnm", $$v)
                      },
                      expression: "regParams.cneCstEnm",
                    },
                  }),
                ],
                1
              ),
            ]),
            _c("tr", [
              _c("th"),
              _c(
                "td",
                { staticClass: "text_left" },
                [
                  _c("ETextarea2", {
                    ref: "actShprCstAddr",
                    attrs: {
                      id: "actShprCstAddr",
                      "max-line": 5,
                      "column-length": 50,
                      "is-char": true,
                    },
                    model: {
                      value: _vm.regParams.actShprCstAddr,
                      callback: function ($$v) {
                        _vm.$set(_vm.regParams, "actShprCstAddr", $$v)
                      },
                      expression: "regParams.actShprCstAddr",
                    },
                  }),
                ],
                1
              ),
              _c("th"),
              _c(
                "td",
                [
                  _c("ETextarea2", {
                    ref: "cneCstAddr",
                    attrs: {
                      id: "cneCstAddr",
                      "max-line": 5,
                      "column-length": 50,
                      "is-char": true,
                    },
                    model: {
                      value: _vm.regParams.cneCstAddr,
                      callback: function ($$v) {
                        _vm.$set(_vm.regParams, "cneCstAddr", $$v)
                      },
                      expression: "regParams.cneCstAddr",
                    },
                  }),
                ],
                1
              ),
            ]),
            _c("tr", [
              _c("th", { staticClass: "text_left" }, [
                _vm._v(" " + _vm._s(_vm.$t("msg.NEWB020G010.047")) + " "),
              ]),
              _c(
                "td",
                [
                  _c("e-trans-address-input", {
                    ref: "ntifCstEnm1",
                    attrs: {
                      id: "ntifCstEnm1",
                      "is-required": true,
                      "is-char": true,
                      "max-length": 50,
                      "message-required": _vm.$t("msg.CSBK100.147"),
                    },
                    on: {
                      input: function ($event) {
                        return _vm.checkValidationInfo("ntifCstEnm1")
                      },
                    },
                    model: {
                      value: _vm.regParams.ntifCstEnm1,
                      callback: function ($$v) {
                        _vm.$set(_vm.regParams, "ntifCstEnm1", $$v)
                      },
                      expression: "regParams.ntifCstEnm1",
                    },
                  }),
                ],
                1
              ),
              _c("th", { staticClass: "text_left" }, [
                _vm._v(" " + _vm._s(_vm.$t("msg.NEWB020G010.048")) + " "),
              ]),
              _c(
                "td",
                [
                  _c("e-trans-address-input", {
                    ref: "ntifCstEnm2",
                    attrs: {
                      id: "ntifCstEnm2",
                      "is-required": false,
                      "is-char": true,
                      "max-length": 50,
                      "message-required": _vm.$t("msg.CSBK100.147"),
                    },
                    model: {
                      value: _vm.regParams.ntifCstEnm2,
                      callback: function ($$v) {
                        _vm.$set(_vm.regParams, "ntifCstEnm2", $$v)
                      },
                      expression: "regParams.ntifCstEnm2",
                    },
                  }),
                ],
                1
              ),
            ]),
            _c("tr", [
              _c("th"),
              _c(
                "td",
                [
                  _c("ETextarea2", {
                    ref: "ntifCstAddr1",
                    attrs: {
                      id: "ntifCstAddr1",
                      "max-line": 5,
                      "column-length": 50,
                      "is-char": true,
                    },
                    model: {
                      value: _vm.regParams.ntifCstAddr1,
                      callback: function ($$v) {
                        _vm.$set(_vm.regParams, "ntifCstAddr1", $$v)
                      },
                      expression: "regParams.ntifCstAddr1",
                    },
                  }),
                ],
                1
              ),
              _c("th"),
              _c(
                "td",
                [
                  _c("ETextarea2", {
                    ref: "ntifCstAddr2",
                    attrs: {
                      id: "ntifCstAddr2",
                      "max-line": 5,
                      "column-length": 50,
                      "is-char": true,
                    },
                    model: {
                      value: _vm.regParams.ntifCstAddr2,
                      callback: function ($$v) {
                        _vm.$set(_vm.regParams, "ntifCstAddr2", $$v)
                      },
                      expression: "regParams.ntifCstAddr2",
                    },
                  }),
                ],
                1
              ),
            ]),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("colgroup", [
      _c("col", { attrs: { width: "14%" } }),
      _c("col", { attrs: { width: "36%" } }),
      _c("col", { attrs: { width: "14%" } }),
      _c("col", { attrs: { width: "36%" } }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }